<template>
  <div class="invite-employee">
    <div class="employee-list" v-if="employeeList && employeeList.length">
      <div class="employee-item" v-for="item in employeeList" :key="item.id">
        <div class="avatar">
          <van-image round width="48" height="48" :src="guest" />
        </div>
        <div class="content">
          <div class="name ellipsis-1">{{item.name}}</div>
          <div class="post ellipsis-1">{{item.post}}</div>
        </div>
        <div class="operate">
          <div class="btn" @click="onSelect(item)">选择</div>
        </div>
      </div>
    </div>
    <Empty v-if="employeeList && !employeeList.length" />

    <Loading v-model="loading" />

    <van-dialog v-model="visible" show-cancel-button confirmButtonColor="#0639EF" confirmButtonText="邀约" @confirm="onConfirm">
      <div class="employee-dialog-content">
        <div class="tip">您将要发起</div>
        <div class="company"> 与{{name}}  <span class="primary">{{current.name}}</span>的邀约 </div>
        <div class="tip-text">根据平台统计，沟通后发起的邀约，成功率可提升80%</div>
      </div>
    </van-dialog>

  </div>
</template>

<script>
  import Loading from '@/components/Loading'
  import Empty from '@/components/Empty'
  import { mapGetters} from 'vuex'
  import guest from '@/assets/guest_default.png'

  export default {
    components: {
      Loading,
      Empty
    },
    data() {
      return {
        guest,
        exhibitorId: "",
        name: "",
        terminal: "wechat",
        employeeList: null,
        loading: false,
        visible: false,
        current: {},
      }
    },
    computed: {
      ...mapGetters(['appId', 'exhibitionId', 'languageType', 'subjectType'])
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.getUrlParams()
        this.getData()
      },
      getUrlParams() {
        const query = this.$route.query
        this.exhibitorId = query.id
        this.projectId = query.projectId
        this.name = decodeURIComponent(query.name)

        this.$store.commit('changeToken', decodeURIComponent(query.token))
        this.$store.commit('changeExhibitionId', query.exhibitionId)
        this.$store.commit('changeAppID', query.appId)
        this.$store.commit('changeSubjectType', query.subjectType)
      },
      getData() {
        const params = {
          appId: this.appId,
          exhibitionId: this.exhibitionId,
          languageType: this.languageType,
          exhibitorId: this.exhibitorId,
          subjectType: this.subjectType,
          terminal: this.terminal,
          pageNum: 1,
          pageRows: 999999
        }
        this.loading = true
        this.$http.getExhibitorEmployeeList(params).then(res => {
          console.log(res)
          if (res.code === 1000) {
            const data = res.data
            this.loading = false
            this.employeeList = data.list || []
          }
        })
      },
      onSelect(item) {
        this.visible = true
        this.current = item
      },
      onConfirm() {
        this.$Toast.success('发送成功')
            wx.miniProgram.navigateBack()
            wx.miniProgram.postMessage({
              data: {
                type: 'exhibitor',
                id: this.exhibitorId
              }
            })
            return
        const params = {
          appId: this.appId,
          exhibitionId: this.exhibitionId,
          languageType: this.languageType,
          subjectType: this.subjectType,
          projectId: this.projectId,
          userId: this.current.id,
          terminal: this.terminal
        }
        this.$http.newAddInviteRecrd(params).then(res => {
          if (res.code === 1000) {
            this.$Toast.success('发送成功')
            wx.miniProgram.navigateBack()
            wx.miniProgram.postMessage({
              data: {
                type: 'exhibitor',
                id: this.exhibitorId
              }
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }
</script>


<style lang="scss" scoped>
  .invite-employee {
    width: 100%;
    background: #fbfbfb;
    min-height: 100vh;
    max-width: 750px;
    margin: 0 auto;
  }
  .employee-list {
    width: 100%;
    padding-bottom: 30px;
    box-sizing: border-box;
    .employee-item {
      width: 100%;
      background: #ffffff;
      display: flex;
      padding: 14px;
      box-sizing: border-box;
      margin-bottom: 10px;
      .avatar {
        width: 48px;
        height: 48px;
      }
      .content {
        flex: 1;
        padding: 4px 0 0 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .name {
          font-weight: 400;
          font-size: 15px;
          color: #140F26;
          min-width: 0;
        }
        .post{
          font-weight: 300;
          font-size: 13px;
          color: #6E7580;
          margin-top: 4px;
          min-width: 0;
        }
      }
      .operate {
        width: 40px;
        display: flex;
        align-items: center;
        .btn {
          font-weight: 400;
          font-size: 12px;
          color: #FFFFFF;
          border-radius: 30px;
          padding: 2px 8px;
          box-sizing: border-box;
          background: linear-gradient(142deg, #163ccc 0%, #973eff 100%);
        }
      }
    }
  }
  .employee-dialog-content {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    .tip {
      font-size: 16px;
      color: #333333;
    }
    .company {
      font-size: 16px;
      color: #333333;
      .primary {
        font-weight: 700;
        color: #0639EF;
      }
    }
    .tip-text {
      width: 100%;
      font-size: 14px;
      color: rgba(0,0,0,.65);
      margin-top: 20px;
    }
  }
</style>